module.exports = __webpack_public_path__ + "img/OVCA_DC.dcde51ef.png";